import { render, staticRenderFns } from "./RevitElements.vue?vue&type=template&id=dbfddeea"
import script from "./RevitElements.vue?vue&type=script&lang=ts"
export * from "./RevitElements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports